/* global Config */

import axios from 'axios';
import { get, isArray, isFunction, isPlainObject, join, set } from 'lodash';

const serviceCaller = (serviceParams, ajaxParams) => {
  const { dispatchCancel, dispatchFetched, dispatchError, dispatchUnauthenticated } = serviceParams;

  // Set header and timeout defaults
  set(ajaxParams, 'headers.X-Requested-With', 'XMLHttpRequest');
  if (ajaxParams.timeout === undefined) {
    ajaxParams.timeout = 30000;
  }

  return axios.request(ajaxParams)
    .then(response => {
      const { data } = response;
      const error = get(data, 'error');

      if (error) {
        dispatchError(getError('response', isPlainObject(error) ? JSON.stringify(error) : error), response);
      } else {
        dispatchFetched(data, response);
      }
    })
    .catch(error => {
      const { message, response } = error;
      let errorText;

      if (!axios.isCancel(error)) {
        if (response) {
          const { config, data, status, statusText } = response;

          if (data && data.error) {
            errorText = data.error;
          } else if (status === 401) {
            errorText = 'Unauthorized';
          } else if (status === 404) {
            errorText = 'Not Found';
          } else if (data && isArray(data) && data.length > 0) {
            errorText = join(data, '. ');
          } else if (statusText && statusText !== 'error') {
            errorText = statusText;
          } else if (message && message !== 'error') {
            errorText = message;
          }

          errorText += `.  Status code: ${status}.`;
          const additionalServices = Config.base.additionalServices || 'undefined';
          const notIsAdditionalService = !config.baseURL || !additionalServices.includes(config.baseURL);

          if (status === 401 && isFunction(dispatchUnauthenticated) && notIsAdditionalService) {
            dispatchUnauthenticated(errorText);
          }
        } else if (message && message !== 'error') {
          errorText = message;
        } else {
          errorText = 'An unknown error has occurred';
        }

        if (Config.base.env === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }

        dispatchError(getError('request', errorText), error);
      } else if (dispatchCancel) {
        dispatchCancel(error);
      }
    });
};

const getError = (type, error) => `There was a problem with the ${type}: ${error}`;

export default serviceCaller;
